import { render, staticRenderFns } from "./StudentActivity.vue?vue&type=template&id=42733eff&scoped=true"
import script from "./StudentActivity.vue?vue&type=script&lang=js"
export * from "./StudentActivity.vue?vue&type=script&lang=js"
import style0 from "./StudentActivity.vue?vue&type=style&index=0&id=42733eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42733eff",
  null
  
)

export default component.exports